import { transformListSelect } from "utils/utils";

export const FIELDS_TYPES = {
  EAN: "Código de Barras",
  PROD_DESCRICAO: "Descrição do Produto",
  CNPJ: "CNPJ",
};

export const FIELDS_TYPES_LIST = transformListSelect(FIELDS_TYPES);
